import React from 'react';

import ValidationFiles from './validation-files';
import ValidationSteps from './validation-steps';
import { MENU_ENTRIES } from '../constants';

const Index = ({ onSectionChange }) => {
  return (
    <div data-subsection={MENU_ENTRIES.xmlValidation}>
      <h3>
        STEP 2: VALIDATING YOUR XML FILE
      </h3>
      <ValidationFiles/>
      <br/>
      <ValidationSteps onSectionChange={onSectionChange}/>
    </div>
  );
};

export default Index;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/xml-validation/index.js